import { Grid } from "@mui/material";
import Step from "./step";
import { useTranslation } from "react-i18next";

type Props = {
  currentStep: number;
};
const Stepper: React.FC<Props> = ({ currentStep }: Props) => {
  const { t } = useTranslation();

  return (
    <Grid container spacing={1} mb={5}>
      <Grid
        container
        sx={{
          // display: "flex",
          display: { xs: "none", sm: "flex" },
          flexDirection: { xs: "column", sm: "row" },
          alignItems: { xs: "center", sm: "start" },
        }}
      >
        <Grid item xs={12} sm={6} sx={{ width: "95%", my: 1 }}>
          <Step title={t("Personal information")} currentStep={currentStep} step={1} />
        </Grid>
        <Grid item xs={12} sm={6} sx={{ width: "95%", my: 1 }}>
          <Step title={t("Business information")} currentStep={currentStep} step={2} />
        </Grid>

      </Grid>
    </Grid>
  );
};

export default Stepper;
